<template>
  <transition name="modal" v-if="visible">
    <div class="[ modal-bg ] fixed inset-0 w-full h-screen flex items-center justify-center bg-gray-900 bg-opacity-80 m-0 py-4 px-3 transition-all duration-300 ease-in-out z-modal-bg">

      <div class="[ modal-wrapper ] bg-white rounded-md flex flex-col md:w-96 min-w-content max-w- md:min-w-min shadow-sm-intense">

        <header class="p-4 mb-0 bg-pink-200 rounded-t-md">
          <h1 class="pt-2 text-normal text-center font-bold text-pink-800 uppercase mb-0">{{ title }}</h1>
        </header>

        <main class="px-4 py-6 border border-pink-100">
          <p v-html="text"></p>
        </main>

        <footer class="relative flex items-center justify-between w-full p-4">
          <button class="btn btn-border" @click="hide">Close</button>
          <button class="btn btn-full" @click="confirm">Confirm</button>
        </footer>

      </div>
    </div>
  </transition>
</template>

<script>
// we must import our Modal plugin instance
// because it contains reference to our Eventbus
import Modal from '../Modal.js'

export default {
  data () {
    return {
      visible: false,
      title: '',
      text: '',
      // adding callback function variable
      onConfirm: {}
    }
  },
  methods: {
    // method for closing modal
    hide () {
      this.visible = false
    },
    confirm () {
      // we must check if this.onConfirm is function
      if (typeof this.onConfirm === 'function') {
        // run passed function and then close the modal
        this.onConfirm()
        this.hide()
      }
      else {
        // we only close the modal
        this.hide()
      }
    },
    // making modal visible
    show (params) {
      this.visible = true
      // setting title and text
      this.title = params.title
      this.text = params.text
      // setting callback function
      this.onConfirm = params.onConfirm
    }
  },
  beforeMount () {
    // here we need to listen for emited events
    // we declared those events inside our plugin
    Modal.EventBus.$on('show', (params) => {
      this.show(params)
    })
  }
}
</script>

<style scoped lang="postcss">
.btn {
  @apply px-2 py-2 rounded-md leading-none transition-all duration-300;
}

.btn-full {
  @apply bg-pink-800 text-pink-200 ring-2 ring-offset-2 ring-pink-800 ring-offset-white ring-opacity-0;
}

.btn-full:hover {
  @apply bg-pink-700 text-white ring-opacity-100;
}

.btn-border {
  @apply border-2 border-transparent bg-white text-pink-800;
}

.btn-border:hover {
  @apply border-pink-700 text-pink-700;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s, scale 0.3s;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
